import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Badge,
  Box,
  Container,
  Tabs,
  Tab,
  Stack
} from '@mui/material';
import { ShoppingCart, Phone, Home } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const Navbar = ({ categories = ['All', 'Floral', 'Fresh', 'Oriental', 'Woody', 'Citrus', 'Gift Sets'], selectedCategory, setSelectedCategory }) => {
  const { getCartCount } = useCart();

  return (
    <div className="appbar">
    <AppBar position="sticky" sx={{ backgroundColor: '#2C3E50' }}>
      <Container maxWidth="lg">
        {/* Top bar with home, phone, and cart */}
        <Toolbar sx={{ borderBottom: '1px solid rgba(218, 165, 32, 0.2)' }}>
          <IconButton 
            component={Link} 
            to="/" 
            sx={{ color: '#DAA520' }}
          >
            <Home />
          </IconButton>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            color: '#DAA520'
          }}>
            <Phone sx={{ mr: 1 }} />
            <Typography variant="body1" sx={{ fontFamily: 'serif' }}>
              Call us: (732) 444-2443
            </Typography>
          </Box>
          <Typography
            variant="h4"
            component={Link}
            to="/"
            sx={{ 
              flexGrow: 1, 
              textDecoration: 'none', 
              color: '#DAA520',
              fontFamily: 'serif',
              textAlign: 'center',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
            }}
          >
            Sunkara Luxury Perfumes
          </Typography>
          <IconButton 
            color="inherit" 
            component={Link} 
            to="/cart"
            sx={{ color: '#DAA520' }}
          >
            <Badge badgeContent={getCartCount()} color="error">
              <ShoppingCart />
            </Badge>
          </IconButton>
        </Toolbar>

        {/* Categories menu */}
        <Tabs
          value={selectedCategory}
          onChange={(e, newValue) => setSelectedCategory(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              color: '#FFF',
              '&.Mui-selected': {
                color: '#DAA520',
                fontWeight: 'bold'
              }
            },
            minHeight: '48px'
          }}
        >
          {categories.map(category => (
            <Tab
              key={category}
              label={category}
              value={category}
              sx={{
                '&.Mui-selected': {
                  color: '#DAA520',
                  fontWeight: 'bold'
                }
              }}
            />
          ))}
        </Tabs>
      </Container>
    </AppBar>
    </div>
  );
};

export default Navbar;
